// extracted by mini-css-extract-plugin
export default {"header":"DataRequestsPage_header__mq9FV","divider":"DataRequestsPage_divider__0-AWj","content":"DataRequestsPage_content__vzx1+","listRoot":"DataRequestsPage_listRoot__+VG+V"};